import 'react-app-polyfill/ie11.js';
import 'url-search-params-polyfill';
import 'url-polyfill';
import 'whatwg-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import { enableES5 } from 'immer';
import {
    getAllEmptyViewModels,
    MedicalProfessionalPersonalInfoViewModel,
    overrideComponent, postVerificationSizeUpdates, setOptions, setViewModel, StepComponent,
} from '@sheerid/jslib';

import { StepMedicalProfessionalPersonalInfoComponent } from './components/steps/StepMedicalProfessionalPersonalInfoComponent';
import { StepSuccessComponent } from './components/steps/StepSuccessComponent';
import { marinerNumberValidator } from './lib/validators/customFieldValidators';
import './index.css';
import App from './App';

import { defaultOptions } from './programOptions';
import { googleTagManagerHook } from './hooks/hooks';

setOptions(defaultOptions);
googleTagManagerHook();
postVerificationSizeUpdates();
enableES5();

marinerNumberValidator();

overrideComponent('StepMedicalProfessionalPersonalInfoComponent', StepMedicalProfessionalPersonalInfoComponent as unknown as StepComponent);
overrideComponent('StepSuccessComponent', StepSuccessComponent as unknown as StepComponent);

const defaultViewModel: MedicalProfessionalPersonalInfoViewModel = getAllEmptyViewModels().collectStudentPersonalInfo as MedicalProfessionalPersonalInfoViewModel;
defaultViewModel.localeChoice = { value: 'en-US', label: 'English' };
defaultViewModel.status = undefined;
defaultViewModel.country = undefined;
defaultViewModel.postalCode = undefined;
setViewModel(defaultViewModel);

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
